import { browseContent } from '@/features/cms/content/browse'
import { HIGH_QUALITY_VIDEO_ID, STANDARD_QUALITY_VIDEO_ID } from './config'

const BASE_WATCH_SEGMENTS: Record<string, string> = {
  'hd-film': HIGH_QUALITY_VIDEO_ID,
  'standard-film': STANDARD_QUALITY_VIDEO_ID,
  [browseContent.mainContent.intro.slug]: browseContent.mainContent.intro.videoId,
  [browseContent.mainContent.trailer.slug]: browseContent.mainContent.trailer.videoId,
}

// Legacy alias (kept so old links still work). Canonical is `/watch/standard-film`.
const LEGACY_WATCH_ALIASES: Record<string, string> = {
  'sd-film': STANDARD_QUALITY_VIDEO_ID,
}

const EXTENDED_INTERVIEWS_SLUG_TO_ID: Record<string, string> =
  browseContent.extendedInterviews.reduce(
    (acc, item) => {
      acc[item.slug] = item.videoId
      return acc
    },
    {} as Record<string, string>,
  )

const CANONICAL_WATCH_SEGMENT_TO_ID: Record<string, string> = {
  ...BASE_WATCH_SEGMENTS,
  ...EXTENDED_INTERVIEWS_SLUG_TO_ID,
}

export const WATCH_SEGMENT_TO_ID: Record<string, string> = {
  ...CANONICAL_WATCH_SEGMENT_TO_ID,
  ...LEGACY_WATCH_ALIASES,
}

const ID_TO_WATCH_SEGMENT = Object.entries(CANONICAL_WATCH_SEGMENT_TO_ID).reduce<
  Record<string, string>
>((acc, [segment, id]) => {
  acc[id] = segment
  return acc
}, {})

export function getWatchPathSegment(videoId: string) {
  return ID_TO_WATCH_SEGMENT[videoId] ?? videoId
}

export function resolveVideoId(segment: string) {
  return WATCH_SEGMENT_TO_ID[segment] ?? segment
}

const PUBLIC_WATCH_SEGMENTS: Set<string> = new Set([browseContent.mainContent.trailer.slug])

export function isPublicWatchSegment(segment: string) {
  return PUBLIC_WATCH_SEGMENTS.has(segment)
}

export function getContentBySlug(slug: string) {
  const { mainContent } = browseContent
  const { extendedInterviews } = browseContent

  if (slug === mainContent.film.slug || slug === 'standard-film') {
    return mainContent.film
  }

  if (slug === mainContent.intro.slug) {
    return mainContent.intro
  }

  if (slug === mainContent.trailer.slug) {
    return mainContent.trailer
  }

  return extendedInterviews.find((item) => item.slug === slug)
}

export function getContentByVideoId(videoId: string) {
  const { mainContent } = browseContent
  const { extendedInterviews } = browseContent

  if (videoId === mainContent.film.videoId || videoId === mainContent.film.standardVideoId) {
    return mainContent.film
  }

  if (videoId === mainContent.intro.videoId) {
    return mainContent.intro
  }

  if (videoId === mainContent.trailer.videoId) {
    return mainContent.trailer
  }

  return extendedInterviews.find((item) => item.videoId === videoId)
}
